import { ifAuthenticated, ifTeamSettings } from '../utils/authorization.js';

export default [
    {
        path: '/configs',
        component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/Configs.vue'),
        beforeEnter: ifAuthenticated,
        children: [
            {
                path: 'organization/details',
                name: 'configs.team.details',
                component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/OrganizationDetails.vue'),
                beforeEnter: ifTeamSettings,
                meta: {
                    title: 'configs.pageTitle',
                },
            },
            {
                path: 'organization/users',
                name: 'configs.team.users',
                component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/OrganizationUsers.vue'),
                beforeEnter: ifTeamSettings,
                meta: {
                    title: 'configs.pageTitle',
                },
            },
            {
                path: 'organization/templates',
                name: 'configs.team.templates',
                component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/OrganizationTemplates.vue'),
                meta: {
                    title: 'configs.pageTitle',
                },
            },
            {
                path: 'user/profile',
                name: 'configs.user.profile',
                component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/UserProfile.vue'),
                meta: {
                    title: 'configs.pageTitle',
                },
            },
            {
                path: 'user/notifications',
                name: 'configs.user.notifications',
                component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/UserNotifications.vue'),
                meta: {
                    title: 'configs.pageTitle',
                },
            },
            {
                path: 'user/messages',
                name: 'configs.user.messages',
                component: () => import(/* webpackChunkName: "configs" */ '../views/Configs/UserMessages.vue'),
                meta: {
                    title: 'configs.pageTitle',
                },
            },
        ],
    },
];
